export function sort<T>(arr: T[], projection: (T) => string): T[] {
    if(arr === null || arr === undefined) {
        return arr;
    }

    return [...arr].sort((a, b) => projection(a)?.toLowerCase().localeCompare(projection(b)?.toLowerCase()));
}